// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"ClientWallet_footerContainer__fy5YQ","savePackageButton":"ClientWallet_savePackageButton__35irq"};